<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Session about to expire</div>
          <p>The application has been idle for too long. <br>
          Session expires in:</p>
          <v-progress-circular
            :rotate="360"
            :size="70"
            :width="2"
            :value="second * 10"
            color="error"
            class="mb-4 mr-4"
          >
            {{ second }}
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	data() {
		return {
      time: 10000,
      dialog: true,
		}
	},
	computed: {
		isIdle() {
			return this.$store.state.idleVue.isIdle;
    },
    second() {
      return this.time / 1000;
    },
  },
	created() {
    let timerId = setInterval(() => {
      if (this.isIdle) {
        this.time -= 1000;
        if (this.time == 0) {
          clearInterval(timerId);
          // Your logout function should be over here
          this.$store.dispatch('auth/logout');
          this.$router.push('/login');
        }
      } else {
        this.time = 10000;
        clearInterval(timerId);
      }
    }, 1000);
  }
}
</script>
